// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1__b0a4030f62b4a78176fa","cls2":"NewsInteractionBar-cls2___79dd7958a881ccab875 NewsInteractionBar-cls1__b0a4030f62b4a78176fa"};